<app-header></app-header>

<div class="content-scroll" #scroller>
  <main class="page-shell" #routeHost>
    <router-outlet (activate)="onActivate()"></router-outlet>
  </main>

  <app-footer></app-footer>
</div>

@if (showScrollTop()) {
<button
  class="scroll-top"
  (click)="scrollToTop()"
  aria-label="Volver arriba">
  <img src="/icons/arrow-up.svg" alt="Volver arriba" />
</button>
}